
import { Component, Vue, Watch } from "vue-property-decorator";
import TipMessages from "@/views/scanforroughsorting/TipMessages.vue";
import {ScanforSixScanModule} from "@/store/modules/store_scanforsixscan";

@Component({
  name: "Form1",
  components: {TipMessages},
})
export default class extends Vue {
  private inputModel: inputDataModel_RoughSorting = {
    input_ScanCode: ""
  };
}
